import { type KeyboardEvent, useCallback } from 'react'
import { type Observable } from 'rxjs'
import { DateInput } from '@/components/inputs/DateInput'

export interface DateTimeQuestionAnswerEditorProps {
  value: Date | null
  collectTime: boolean
  minDate?: Date
  maxDate?: Date
  isDisabled: boolean
  onChange: (value: Date | undefined) => unknown
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
  isNotValid?: boolean
  testId?: string
}

export function DateTimeQuestionAnswerEditor({
  value,
  collectTime,
  minDate,
  maxDate,
  isDisabled,
  onChange,
  onEnterDown,
  onFocus,
  focus$,
  isNotValid,
  testId,
}: DateTimeQuestionAnswerEditorProps) {
  const keyDown = useCallback(
    (e: KeyboardEvent) => e.key === 'Enter' && onEnterDown?.(e),
    [onEnterDown],
  )

  return (
    <DateInput
      focus$={focus$}
      onFocus={onFocus}
      value={value ?? undefined}
      onChange={onChange}
      includeTime={collectTime}
      isDisabled={isDisabled}
      onKeyDown={keyDown}
      minDate={minDate}
      maxDate={maxDate}
      isNotValid={isNotValid}
      testId={testId}
    />
  )
}
